import { Button } from "@ndd/ui";
import type { MeetingNoteData } from "./meeting-note-types";
import { MeetingNoteRow } from "./meeting-note-row";

interface MeetingNotesPanelProps {
  notes: MeetingNoteData[];
  onAdd: () => void;
  onSelect: (note: MeetingNoteData) => void;
  /**
   * Workspace surface mode: the list runs full height (the page scrolls)
   * instead of scrolling inside a fixed-height card viewport.
   */
  surface?: boolean;
}

export function MeetingNotesPanel({
  notes,
  onAdd,
  onSelect,
  surface = false,
}: MeetingNotesPanelProps) {
  if (notes.length === 0) {
    return (
      <div className="px-5 py-10 text-center text-muted-foreground">
        <div className="mb-1.5 font-sans text-title-sm font-semibold text-muted-strong">
          No meeting notes yet
        </div>
        <p className="text-sm">
          Saved RD check-in notes will appear here in reverse chronological order.
        </p>
        <div className="mt-4">
          <Button onClick={onAdd}>+ Add Meeting Note</Button>
        </div>
      </div>
    );
  }

  return (
    <>
      <div
        className={
          surface ? "border-t border-border bg-card" : "max-h-[360px] overflow-y-auto"
        }
      >
        {notes.map((note) => (
          <MeetingNoteRow key={note.id} note={note} onSelect={onSelect} />
        ))}
      </div>
      {surface && (
        <p className="pb-2 pt-5 text-center text-xs text-subtle">
          {notes.length} of {notes.length} meeting note
          {notes.length === 1 ? "" : "s"}
        </p>
      )}
    </>
  );
}
